import sanityClient from "@sanity/client";

export default sanityClient({
	projectId: "24m9tu5n",
	dataset: "production",
	apiVersion: "2021-08-31",
	useCdn: true,
});
